(function(angular){
	'use strict';
	
	angular
		.module('popoverModule')
		.directive('popover', [
			'$window',
			popoverFunction
		]);
	
	function popoverFunction($window){
		return {
			restrict: 'A',
			scope: {
				popover: '@'
			},
			link: function(scope, elem, attr) {

				var removePopover = function() {
					var popover = document.getElementById('popover');
					popover = angular.element(popover);
					popover.remove();
				};

				var addPopover = function() {
					var timestamp = Date.now();
					var dataId = 'popover-' + timestamp;

					var newPopover = angular.element('<div id="popover" data-id="' + dataId + '" class="popover"><div class="popover__content">' + attr.popover + '</div><div id="popover-arrow" class="popover__arrow"></div></div>');
					var position = elem[0].getBoundingClientRect();
					var distanceFromTop = position.top + $window.pageYOffset;
					var distanceFromLeft = position.left + $window.pageXOffset;

					document.body.appendChild(newPopover[0]);

					var placedPopover = document.getElementById('popover');
					var popoverArrow = document.getElementById('popover-arrow');

					placedPopover.style.top = distanceFromTop - placedPopover.offsetHeight - 16 + 'px';
					placedPopover.style.left = distanceFromLeft + (elem[0].offsetWidth / 2) - (placedPopover.offsetWidth / 2) + 'px';

					var placedPopoverRightEdge = placedPopover.offsetLeft + placedPopover.offsetWidth;
					var overflowLeft = placedPopover.offsetLeft * -1;
					var overflowRight = placedPopoverRightEdge - document.body.clientWidth;

					if(overflowLeft > 0) {
						popoverArrow.style.left = popoverArrow.offsetLeft - overflowLeft - 16 + 'px';
						popoverArrow.style.marginLeft = 0;
						placedPopover.style.left = placedPopover.offsetLeft + overflowLeft + 16 + 'px';
					}

					if(overflowRight > 0) {
						popoverArrow.style.left = popoverArrow.offsetLeft + overflowRight + 16 + 'px';
						popoverArrow.style.marginLeft = 0;
						placedPopover.style.left = placedPopover.offsetLeft - overflowRight - 16 + 'px';
					}

					placedPopover.className = placedPopover.className + ' popover--state-active';

					scope.dataId = dataId;
				};

				var popoverExists = function() {
					var popover = document.getElementById('popover');
					
					return popover !== null;
				};

				var popoverBelongsToTrigger = function() {
					var popover = document.getElementById('popover');

					if (popover) {
						var dataId = popover.getAttribute('data-id');
						return scope.dataId === dataId;
					} else {
						return false;
					}
				};

				var element = document.getElementsByTagName('body')[0];
				var body = angular.element(element);
				body.on('click', function(e) {
					var dismiss = true;

					angular.forEach(e.path, function(el) {
						if(el.id === 'popover') {
							dismiss = false;
						}
					});

					if(dismiss) {
						removePopover();
					}
				});

				elem.on('click', function(e) {
					var addNewPopover = !popoverBelongsToTrigger();

					if(popoverExists()) {
						removePopover();
						if(addNewPopover) {
							addPopover();
						}
					} else {
						addPopover();
					}

					if ($window.mixpanel){
						mixpanel.track("Popover Clicked", {
							"Text Clicked": e.target.innerText
						});
					}
					
					e.stopPropagation();
				});
			}
		};
	}
})(window.angular);